import { Box, Stack, Typography } from "@mui/material";
import { brand } from "../theme";

// Read-only figures the form works out (maturity date, daily premium)
export default function PolicySummary({ items }) {
  return (
    <Stack
      direction="row"
      gap={3}
      flexWrap="wrap"
      sx={{ p: 1.75, borderRadius: 2, bgcolor: "#F6F8F9", border: `1px dashed ${brand.border}` }}
    >
      {items.map(({ label, value }) => (
        <Box key={label}>
          <Typography variant="caption" color="text.secondary">
            {label}
          </Typography>
          <Typography sx={{ fontWeight: 650, fontVariantNumeric: "tabular-nums" }}>{value}</Typography>
        </Box>
      ))}
    </Stack>
  );
}
